import { render, staticRenderFns } from "./articleupdate.vue?vue&type=template&id=ecf8b9be&scoped=true&"
import script from "./articleupdate.vue?vue&type=script&lang=js&"
export * from "./articleupdate.vue?vue&type=script&lang=js&"
import style0 from "./articleupdate.vue?vue&type=style&index=0&id=ecf8b9be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf8b9be",
  null
  
)

export default component.exports